import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Popover } from "antd";
import classNames from "classnames";
// import { IconMore } from '@/components/icon';
// import { Avatar } from '@jd/focus-desktop-comps';
import { Avatar } from "@/baseComponents/Avatar";
import { changeEgovUrl, crossAppSwitch, isMebjJZB } from "@/utils/tools";
import IconFont from "@/components/icon";
import { connect } from "dvajs";
import ChatState from "@/types/chat/State";
import ImService from "@/server/ImService";
import { ClientType, Employee } from "@/types/chat";
import { getClientType, isFocusEnv } from "@/utils";
import CreateTeamWithLoginModal from "@/components/LoginComp/forms/JoinMe/CreateTeamWithLoginModal";
import bus from "@/utils/bus";
import { useTranslation, WithTranslation } from "react-i18next";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { TeamUserInfo } from "@/types/LoginPage";
import _ from "lodash";
import { AuthData } from "@/types/LocalConfig";
import { getUserTeamInfo } from "@/api/user";
import UserGuideTeamBadge from "@/components/Modals/UserGuideTeamBadge";
import { Curvature } from "@/assets/svg";

export interface TeamItemInfo {
  emplEnabled?: string;
  account: string;
  ddAppId: string;
  headImg: string | null;
  mobile: string;
  realName: string;
  teamAvatarUrl?: string;
  teamFullName: string;
  teamId: string;
  teamShortName: string;
}

function TeamItem({
  team,
  onClick,
  hasDot,
  newDotNum,
  themes
}: {
  team: TeamItemInfo;
  onClick?: any;
  hasDot: boolean;
  newDotNum?: number;
  themes?: any;
}) {
  const newDotNumStr = useMemo(() => {
    return newDotNum && newDotNum > 99 ? `${isMebjJZB() ? "..." : "99+"}` : newDotNum;
  }, [newDotNum]);
  const avatar = (
    <div className="avatar-wrap">
      <div
        style={{
          position: "relative",
          width: 34,
          height: 34,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <div className="curvature-wrap" style={{ position: "absolute", inset: 0 }}>
          <Curvature />
        </div>
        <Avatar
          src={changeEgovUrl(team.teamAvatarUrl || "")}
          name={team.teamFullName}
          type="team"
          styleObj={{
            width: 28,
            height: 28,
            borderRadius: 0,
            fontSize: 10,
            background: "#1686FF",
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)"
          }}
        />
      </div>

      <span className={`avatar-wrap-more ${themes}`}>
        <IconFont type="iconFrame7" style={{ fontSize: "16px" }} />
      </span>
      {hasDot && newDotNum ? (
        <span
          className={classNames("team-unread-tip", "dot", "total", {
            dotM: true
          })}
        >
          {newDotNumStr}
        </span>
      ) : null}
    </div>
  );
  const comp = (
    <div
      className="teamListItem"
      style={{
        width: 30,
        height: 30,
        borderRadius: 7,
        position: "relative"
      }}
      onClick={onClick}
    >
      {avatar}
    </div>
  );
  // return (
  //     <Tooltip placement="right" title={team.teamShortName} destroyTooltipOnHide>
  //         {comp}
  //     </Tooltip>
  // );
  return comp;
}

const TeamItem1 = ({
  team,
  selected,
  onClick,
  hasDot,
  newDotNum,
  disable = false
}: {
  team: TeamItemInfo;
  selected: boolean;
  onClick?: any;
  hasDot?: boolean;
  newDotNum?: number;
  disable?: boolean;
}) => {
  const newDotNumStr = useMemo(() => {
    return newDotNum && newDotNum > 99 ? `${isMebjJZB() ? "..." : "99+"}` : newDotNum;
  }, [newDotNum]);
  const avatar = (
    <div className="avatar-wrap">
      <Avatar
        src={changeEgovUrl(team.teamAvatarUrl || "")}
        name={team.teamFullName}
        styleObj={{ width: 28, height: 28, borderRadius: 6, border: "none", fontSize: 10, background: "#1686FF" }}
        type="team"
      />
      {hasDot && newDotNum ? (
        <span
          className={classNames("team-unread-tip", "dot", {
            dotM: true
          })}
        >
          {newDotNumStr}
        </span>
      ) : null}
    </div>
  );

  return (
    <div className={`teamListItem ${disable ? "disable" : ""}`} onClick={onClick}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          position: "relative"
        }}
      >
        {avatar}
        <span
          style={{
            fontSize: 12,
            marginLeft: 6,
            flex: 1,
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            width: "160"
          }}
        >
          {team.teamFullName}
        </span>
      </div>
    </div>
  );
};

function TeamListNew(props: {
  onItemClick?: (team: TeamItemInfo) => void;
  otherTeamNotifyList: any;
  loadAllSessionListEnd: boolean;
  currentEmployee: Employee;
  themes?: any;
}) {
  const {
    onItemClick,
    otherTeamNotifyList,
    loadAllSessionListEnd,
    currentEmployee,
    themes
  } = props;

  const { service, authInfo, focusSDK, setAuthInfo } = useContext<GlobalContextConfig>(
    GlobalContext
  );
  const selectedTeamId = authInfo?.selectedTeamId;
  const getOthers = useRef<boolean>(false);
  const [t_common] = useTranslation("common");
  const [visible, setVisible] = useState(false);
  const [useTeams, setUseTeams] = useState(authInfo.teamUserInfoList);
  const selectedTeam = useMemo(() => {
    const team = useTeams.find((t) => {
      return t.teamId === selectedTeamId;
    });
    return team || useTeams[0];
  }, [selectedTeamId, useTeams]);
  useEffect(() => {
    setUseTeams(authInfo.teamUserInfoList);
  }, [authInfo.teamUserInfoList]);
  const refreshTeamList = useCallback(async () => {
    console.log("refreshTeamList");
    try {
      const teamsInfo = await getUserTeamInfo();
      if (!teamsInfo) return;
      const userInfo = _.pick(authInfo, [
        "mobile",
        "email",
        "hasPassword",
        "hasBindMobile",
        "hasBindEmail"
      ]);

      const teamInfoList =
        teamsInfo.teamInfoList?.map((item) => {
          const data: TeamUserInfo = {
            ...item,
            ...userInfo
          };
          return data;
        }) || [];
      const result = _.differenceBy(teamInfoList, authInfo.teamUserInfoList, function (o) {
        return o.teamId;
      });
      if (result.length > 0) {
        //  console.log(result, "changeTeamUserInfoList");
        focusSDK.changeTeamUserInfoList(teamInfoList, () => {
          console.log("changeTeamUserInfoListcb");
          setUseTeams(teamInfoList);
          setVisible(true);
          setAuthInfo((pre: AuthData | null) => {
            if (!pre) return null;
            return {
              ...pre,
              teamUserInfoList: teamInfoList
            };
          });
        });
      } else {
        setVisible(true);
      }
    } catch (e) {
      setVisible(true);
      console.log("get refreshTeamList error--", e);
    }
  }, [authInfo]);
  const hasNew = useMemo(() => {
    return Object.values(otherTeamNotifyList).filter((i) => Number(i) > 0)?.length > 0;
  }, [otherTeamNotifyList]);

  const caclNewDotNum = useMemo(() => {
    try {
      const keys = Object.keys(otherTeamNotifyList);
      if (keys?.length === 0) {
        return 0;
      }
      const sum = Object.values(otherTeamNotifyList).reduce(
        (acc: number, val) => acc + (Number(val) || 0),
        0
      );
      return sum;
    } catch (e) {
      return 0;
    }
  }, [otherTeamNotifyList]);

  const handleCurrentTeamClick = useCallback(
    (e: any) => {
      e?.preventDefault();
      e?.stopPropagation();
      setVisible(!visible);
    },
    [visible]
  );

  const onVisibleChange = useCallback(
    (isVisible: boolean) => {
      console.log(isVisible, "onVisibleChange");
      // setVisible(isVisible);
      if (isVisible) {
        refreshTeamList();
      }
      setVisible(isVisible);
    },
    [refreshTeamList]
  );

  const getPopover = useMemo(() => {
    if (!useTeams.length) {
      return null;
    }
    return (
      <Popover
        placement="rightBottom"
        trigger="click"
        visible={visible}
        destroyTooltipOnHide
        onVisibleChange={onVisibleChange}
        overlayClassName="teamListPopover2"
        overlayStyle={{ marginLeft: "-4px" }}
        content={
          <div className="teamListPopover1">
            {useTeams.map((item) => (
              <div
                id={item.teamId}
                key={item.teamId}
                className={classNames("teamPopoverItem1", {
                  selected: item.teamId === selectedTeamId
                })}
              >
                <TeamItem1
                  disable={!loadAllSessionListEnd}
                  team={item}
                  selected={item.teamId === selectedTeamId}
                  onClick={() => {
                    if (onItemClick && selectedTeamId !== item.teamId) {
                      onItemClick(item);
                    }
                  }}
                  hasDot={!!otherTeamNotifyList[item.teamId]}
                  newDotNum={otherTeamNotifyList[item.teamId] || 0}
                />
              </div>
            ))}
            {isFocusEnv() && crossAppSwitch("selfRegistration") && (
              <>
                <div
                  style={{
                    height: 1,
                    backgroundColor: "#DBDBDC",
                    marginBottom: "4px"
                  }}
                />
                <div
                  className="teamPopoverItemCreateTeam"
                  onClick={() => {
                    setVisible(false);
                    bus.emit("CreateTeamWithLoginVisible", true);
                  }}
                >
                  <div className="CreateTeam-btn">
                    <IconFont type="iconbtn_add" style={{ fontSize: 10, color: "#818793" }} />
                  </div>
                  {t_common("login.CreateOrAddTeam")}
                </div>
              </>
            )}
          </div>
        }
      >
        <div
          className={`${!loadAllSessionListEnd ? "disable" : ""} teamListItem`}
          style={{
            width: 30,
            height: 30,
            marginTop: 20,
            color: "rgba(255, 255, 255, .5)",
            fontSize: 24,
            textAlign: "center"
          }}
        >
          {/* {IconMore} */}
          <TeamItem
            key={selectedTeamId}
            team={selectedTeam}
            hasDot={hasNew}
            newDotNum={caclNewDotNum || 0}
            onClick={handleCurrentTeamClick}
            themes={themes}
          />

          {useTeams.length > 1 ? (
            <UserGuideTeamBadge hasNew={hasNew} onConfirm={() => setVisible(true)} />
          ) : null}
        </div>
      </Popover>
    );
  }, [
    useTeams,
    visible,
    onVisibleChange,
    t_common,
    loadAllSessionListEnd,
    selectedTeamId,
    selectedTeam,
    hasNew,
    caclNewDotNum,
    handleCurrentTeamClick,
    otherTeamNotifyList,
    onItemClick,
    themes
  ]);

  // const doGetOthers = useCallback(() => {
  //   if (getOthers.current) {
  //     return;
  //   }
  //   const params = useTeams
  //     .filter((t) => t.teamId !== selectedTeamId)
  //     .map((t) => {
  //       return {
  //         uid: {
  //           teamId: t.teamId,
  //           app: currentEmployee.app,
  //           pin: currentEmployee.userId,
  //           clientType: getClientType() === "MAC" ? ClientType.MAC : ClientType.PC
  //         },
  //         pageSize: 1
  //       };
  //     });
  //   if (params?.length) {
  //     ImService.getInstance()?.getOtherOfflineMessage(params);
  //   }
  // }, [currentEmployee.app, currentEmployee.userId, selectedTeamId, useTeams]);

  // useEffect(() => {
  //   if (currentEmployee?.userId && loadAllSessionListEnd && !getOthers.current) {
  //     doGetOthers();
  //     getOthers.current = true;
  //   }
  // }, [doGetOthers, loadAllSessionListEnd, currentEmployee?.userId]);

  useEffect(() => {
    getOthers.current = false;
    return () => {
      getOthers.current = false;
    };
  }, []);

  return (
    <div
      className="no-draggable"
      style={{
        paddingBottom: 20,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        position: "relative"
      }}
    >
      {getPopover}
      <CreateTeamWithLoginModal />
    </div>
  );
}
function mapStateToProps({ chat, user }: { chat: ChatState; user: any }) {
  const { otherTeamNotifyList, loadAllSessionListEnd, currentEmployee } = chat;
  const { themes } = user;
  return {
    otherTeamNotifyList,
    loadAllSessionListEnd,
    currentEmployee,
    themes
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(TeamListNew);
